import { SampleData } from "../../stores/Sample";
import { AlignmentOptions } from "../../stores/Search";
import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";
import { SamplesList } from "../SamplesList";

function Sample1125000() {
  const samplesList: SampleData[] = similarSamples.map(
    (sample) =>
      new SampleData(
        sample.sampleText,
        sample.decodedTokens,
        sample.activations,
        sample.normalizedActivations,
        sample.targetIdx,
        sample.absoluteTokenIdx,
        sample.modelId
      )
  );

  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="mini" sampleId="1125000" />
        <span> - </span>
        <SampleQuote text="your doctor may prescribe a mixture" targetIdx={25} targetLength={2} />
      </h4>
      <p>
        Features representing two different topics are present within the final layer of this
        circuit. Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="1125000" featureKey="0.8.983" compact /> responds to
        phrases describing different types of medications. Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="1125000" featureKey="0.8.8466" compact /> responds
        to phrases describing the diagnosis of diabetes. Both of these topic-related features depend
        upon upstream features that respond to words in specific contexts. Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="1125000" featureKey="14.7.292" compact /> responds
        to words associated with diabetes. Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="1125000" featureKey="3.6.4778" compact /> responds
        to words associated with the treatment of an illness.
      </p>
      <figure>
        <figcaption>
          Activations for <FeatureAnchor modelId="mini" sampleId="1125000" featureKey="0.8.983" />
        </figcaption>
        <SamplesList
          samples={samplesList}
          alignment={AlignmentOptions.Token}
          rightPadding={20}
          hideActivation={true}
          showIcon={true}
        />
      </figure>
    </section>
  );
}

const similarSamples = [
  {
    sampleText:
      "Reduce or eliminate caffeinated beverages.Drink alcohol in moderation.Avoid using drugs.Reduce exposure to stressful environments.Exercise regularly.\nPractice deep breathing and\nLearn how to do progressive muscle relaxation.Work with a massage therapist.Engage in pleasurable activities.\nstrong support system of family and friends.Seek therapy to improve your coping skills.\nThis therapy addresses thoughts, feelings, and behaviors that play a role in anxiety. It helps you work through traumas and conflicts.\nCognitive behavioral therapy\ncan help you identify negative thought patterns and behaviors. Over time, you can learn to retrain your thinking. This will help you respond better to stress and anxiety.\nCBT has been very effective in children and teens.\nFor severe anxiety or anxiety disorder, medicines may include: BenzodiazepinesBuspironeAntidepressants (e.g., tricyclic antidepressants, selective serotonin reuptake inhibitors [SSRIs])\nIf you are diagnosed with an anxiety disorder, follow your doctor's\nTo help prevent anxiety, consider taking the following steps: Avoid situations, occupations, and people that cause you stress.If unavoidable, confront and overcome situations that provoke anxiety.Find a relaxation technique that works for you.",
    decodedTokens: [
      "Red",
      "uce",
      " or",
      " eliminate",
      " caffe",
      "inated",
      " beverages",
      ".",
      "Dr",
      "ink",
      " alcohol",
      " in",
      " moderation",
      ".",
      "Avoid",
      " using",
      " drugs",
      ".",
      "Red",
      "uce",
      " exposure",
      " to",
      " stressful",
      " environments",
      ".",
      "Ex",
      "ercise",
      " regularly",
      ".",
      "\n",
      "Pract",
      "ice",
      " deep",
      " breathing",
      " and",
      "\n",
      "Learn",
      " how",
      " to",
      " do",
      " progressive",
      " muscle",
      " relaxation",
      ".",
      "Work",
      " with",
      " a",
      " massage",
      " therapist",
      ".",
      "Eng",
      "age",
      " in",
      " pleas",
      "urable",
      " activities",
      ".",
      "\n",
      "strong",
      " support",
      " system",
      " of",
      " family",
      " and",
      " friends",
      ".",
      "Se",
      "ek",
      " therapy",
      " to",
      " improve",
      " your",
      " coping",
      " skills",
      ".",
      "\n",
      "This",
      " therapy",
      " addresses",
      " thoughts",
      ",",
      " feelings",
      ",",
      " and",
      " behaviors",
      " that",
      " play",
      " a",
      " role",
      " in",
      " anxiety",
      ".",
      " It",
      " helps",
      " you",
      " work",
      " through",
      " tra",
      "um",
      "as",
      " and",
      " conflicts",
      ".",
      "\n",
      "C",
      "ognitive",
      " behavioral",
      " therapy",
      "\n",
      "can",
      " help",
      " you",
      " identify",
      " negative",
      " thought",
      " patterns",
      " and",
      " behaviors",
      ".",
      " Over",
      " time",
      ",",
      " you",
      " can",
      " learn",
      " to",
      " ret",
      "rain",
      " your",
      " thinking",
      ".",
      " This",
      " will",
      " help",
      " you",
      " respond",
      " better",
      " to",
      " stress",
      " and",
      " anxiety",
      ".",
      "\n",
      "C",
      "BT",
      " has",
      " been",
      " very",
      " effective",
      " in",
      " children",
      " and",
      " teens",
      ".",
      "\n",
      "For",
      " severe",
      " anxiety",
      " or",
      " anxiety",
      " disorder",
      ",",
      " medicines",
      " may",
      " include",
      ":",
      " Benz",
      "od",
      "iazep",
      "ines",
      "Bus",
      "pir",
      "one",
      "Ant",
      "idepress",
      "ants",
      " (",
      "e",
      ".",
      "g",
      ".,",
      " tr",
      "icy",
      "cl",
      "ic",
      " antidepressants",
      ",",
      " selective",
      " serotonin",
      " re",
      "upt",
      "ake",
      " inhibitors",
      " [",
      "SS",
      "R",
      "Is",
      "])",
      "\n",
      "If",
      " you",
      " are",
      " diagnosed",
      " with",
      " an",
      " anxiety",
      " disorder",
      ",",
      " follow",
      " your",
      " doctor",
      "'s",
      "\n",
      "To",
      " help",
      " prevent",
      " anxiety",
      ",",
      " consider",
      " taking",
      " the",
      " following",
      " steps",
      ":",
      " Avoid",
      " situations",
      ",",
      " occupations",
      ",",
      " and",
      " people",
      " that",
      " cause",
      " you",
      " stress",
      ".",
      "If",
      " unavoidable",
      ",",
      " confront",
      " and",
      " overcome",
      " situations",
      " that",
      " provoke",
      " anxiety",
      ".",
      "Find",
      " a",
      " relaxation",
      " technique",
      " that",
      " works",
      " for",
      " you",
      ".",
    ],
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.387, 0, 0, 0, 0, 0.349, 0.629, 0.497, 0, 0, 0, 0, 0, 0, 0,
      0.245, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.477, 1.293, 1.039, 1.317, 1.554, 0.993, 0.649, 0.403,
      1.731, 0.401, 0.857, 1.609, 1.17, 0.611, 1.526, 1.293, 0.997, 0, 0, 1.983, 1.032, 0.428,
      0.679, 0.7, 1.333, 1.56, 0.769, 0.203, 0.579, 0, 0.77, 1.17, 0.626, 0.409, 0.518, 0.576,
      1.504, 0.494, 0.373, 0.418, 0, 0, 0, 0, 0, 0, 0.545, 0.299, 0, 0, 0, 0, 0, 0, 0, 0, 0.433, 0,
      1.13, 0.65, 0.754, 0, 0.643, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.19520160741113896, 0, 0, 0, 0, 0.17603452451288756,
      0.31726566165789766, 0.2506852684323929, 0, 0, 0, 0, 0, 0, 0, 0.12357724500188383, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.2405973300648922, 0.6521852154589216, 0.5240683981916624,
      0.6642907414999225, 0.7838328111548061, 0.5008661399464108, 0.32735360002539843,
      0.20327195810513954, 0.8731110657071874, 0.20226316426838947, 0.4322681590474059,
      0.811574641665433, 0.5901443944987922, 0.308186517127147, 0.769709697440305,
      0.6521852154589216, 0.502883727619911, 0, 0, 1.0002190891376965, 0.5205376197630373,
      0.21588188106451542, 0.34248550757664953, 0.35307784286252525, 0.672361092193923,
      0.7868591926650563, 0.3878812302304027, 0.10239257443013233, 0.29204581573914584, 0,
      0.3883856271487778, 0.5901443944987922, 0.3157524709027726, 0.20629833961538974,
      0.2612776037182687, 0.29053262498402077, 0.7586129652360543, 0.24917207767726782,
      0.18814005055388844, 0.21083791188076506, 0, 0, 0, 0, 0, 0, 0.27489632051439467,
      0.15081467859413578, 0, 0, 0, 0, 0, 0, 0, 0, 0.2184038656563906, 0, 0.5699685177637906,
      0.32785799694377343, 0.3803152764547772, 0, 0.3243272185151482, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    targetIdx: 180,
    absoluteTokenIdx: 3764404,
    modelId: "mini",
  },
  {
    sampleText:
      " If the menstruation begins prior to the age of 10 years or does not begin till the age of 16 years, the girl should consult the doctor. Hormonal imbalance, genetic defect, ill health, anaemia, poor nutrition or anatomical abnormality of the sex organs (small uterus, imperforate hymen) could be the cause for the delay. Some girls complain of white discharge before the commencement of the menstruation. This is normal as long as the discharge is not offensive. Menstruation is associated with pain in its initial years. This is normal.\nPain may be in the lower abdomen or in the back. It is supposed to be due to the cramps of the uterus or due to passing of blood clots through a tight cervix. If the pain is mild, the girl should involve her mind in her normal activities so as to deviate her mind. If the pain is severe, she should take rest in the bed and use a hot water bottle for fomentation. She may need for the relief of pain a tablet like Paracetamol, Mefenamic Acid, Codein; or a spasm-relieving drug like Dicyclomine. She should take the drug only as per the advice of her doctor since",
    decodedTokens: [
      " If",
      " the",
      " menstru",
      "ation",
      " begins",
      " prior",
      " to",
      " the",
      " age",
      " of",
      " 10",
      " years",
      " or",
      " does",
      " not",
      " begin",
      " till",
      " the",
      " age",
      " of",
      " 16",
      " years",
      ",",
      " the",
      " girl",
      " should",
      " consult",
      " the",
      " doctor",
      ".",
      " H",
      "ormonal",
      " imbalance",
      ",",
      " genetic",
      " defect",
      ",",
      " ill",
      " health",
      ",",
      " ana",
      "emia",
      ",",
      " poor",
      " nutrition",
      " or",
      " anatomical",
      " abnorm",
      "ality",
      " of",
      " the",
      " sex",
      " organs",
      " (",
      "small",
      " uterus",
      ",",
      " imper",
      "for",
      "ate",
      " hy",
      "men",
      ")",
      " could",
      " be",
      " the",
      " cause",
      " for",
      " the",
      " delay",
      ".",
      " Some",
      " girls",
      " complain",
      " of",
      " white",
      " discharge",
      " before",
      " the",
      " commencement",
      " of",
      " the",
      " menstru",
      "ation",
      ".",
      " This",
      " is",
      " normal",
      " as",
      " long",
      " as",
      " the",
      " discharge",
      " is",
      " not",
      " offensive",
      ".",
      " Men",
      "stru",
      "ation",
      " is",
      " associated",
      " with",
      " pain",
      " in",
      " its",
      " initial",
      " years",
      ".",
      " This",
      " is",
      " normal",
      ".",
      "\n",
      "Pain",
      " may",
      " be",
      " in",
      " the",
      " lower",
      " abdomen",
      " or",
      " in",
      " the",
      " back",
      ".",
      " It",
      " is",
      " supposed",
      " to",
      " be",
      " due",
      " to",
      " the",
      " cr",
      "amps",
      " of",
      " the",
      " uterus",
      " or",
      " due",
      " to",
      " passing",
      " of",
      " blood",
      " cl",
      "ots",
      " through",
      " a",
      " tight",
      " cerv",
      "ix",
      ".",
      " If",
      " the",
      " pain",
      " is",
      " mild",
      ",",
      " the",
      " girl",
      " should",
      " involve",
      " her",
      " mind",
      " in",
      " her",
      " normal",
      " activities",
      " so",
      " as",
      " to",
      " dev",
      "iate",
      " her",
      " mind",
      ".",
      " If",
      " the",
      " pain",
      " is",
      " severe",
      ",",
      " she",
      " should",
      " take",
      " rest",
      " in",
      " the",
      " bed",
      " and",
      " use",
      " a",
      " hot",
      " water",
      " bottle",
      " for",
      " f",
      "om",
      "ent",
      "ation",
      ".",
      " She",
      " may",
      " need",
      " for",
      " the",
      " relief",
      " of",
      " pain",
      " a",
      " tablet",
      " like",
      " Par",
      "acet",
      "am",
      "ol",
      ",",
      " M",
      "ef",
      "en",
      "amic",
      " Acid",
      ",",
      " Code",
      "in",
      ";",
      " or",
      " a",
      " sp",
      "asm",
      "-",
      "rel",
      "ieving",
      " drug",
      " like",
      " D",
      "icy",
      "cl",
      "om",
      "ine",
      ".",
      " She",
      " should",
      " take",
      " the",
      " drug",
      " only",
      " as",
      " per",
      " the",
      " advice",
      " of",
      " her",
      " doctor",
      " since",
    ],
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.708, 0, 0, 0, 0, 0, 0.465, 0, 0.331, 0.403, 0.612, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.363,
      0, 0, 0, 0.747, 0.944, 0, 0.364, 0.311, 1.381, 1.688, 0.505, 0.646, 0.997, 0.949, 1.356,
      1.568, 0.778, 0.791, 1.183, 1.501, 1.251, 0.409, 0.359, 0.518, 0, 1.498, 1.65, 1.965, 1.374,
      0.676, 0.394, 0.649, 1.548, 0.696, 0.499, 0.815, 1.481, 0.939, 1.412, 0.918, 0.614, 0.44, 0,
      0, 0.274, 0, 0, 0.746,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.3571130182095255, 0, 0, 0, 0, 0, 0.23454456704439178, 0, 0.16695537998213694,
      0.20327195810513954, 0.30869091404552207, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.18309608137013808, 0, 0, 0, 0.37678449802615194, 0.476150690946034, 0, 0.1836004782885131,
      0.15686744161463623, 0.6965721442759248, 0.8514219982170609, 0.25472044377939324,
      0.3258404092702733, 0.502883727619911, 0.4786726755379092, 0.6839622213165489,
      0.7908943680120566, 0.39242080249577804, 0.39897796243465355, 0.5967015544376677,
      0.757099774480929, 0.6310005448871701, 0.20629833961538974, 0.18107849369663795,
      0.2612776037182687, 0, 0.755586583725804, 0.8322549153188095, 0.9911399446069459,
      0.6930413658472996, 0.3409723168215244, 0.19873238583976421, 0.32735360002539843,
      0.7808064296445558, 0.35106025518902506, 0.251694062269143, 0.41108348847565435,
      0.7470118361134285, 0.4736287063541588, 0.7122084487455509, 0.4630363710682831,
      0.30969970788227213, 0.22193464408501587, 0, 0, 0.1382047556347599, 0, 0, 0.3762801011077769,
    ],
    targetIdx: 235,
    absoluteTokenIdx: 5460459,
    modelId: "mini",
  },
  {
    sampleText:
      " your brain. Triptans often may relieve pain from your headache within two hours and help to control vomiting.\n- Take pain relievers and triptans. Some women may take a combination of NSAIDs and triptans to relieve pain from menstrual migraines.\n- Take other prescription pain medications. Sometimes your doctor may suggest other prescription pain medications, such as dihydroergotamine (Dihydroergotamine Mesylate).\nIf you have several debilitating headaches a month, your doctor may recommend preventive treatment with NSAIDs or triptans.\nIf your menstrual cycle is regular, it's often most effective to take preventive headache medication starting a few days before your period and continuing through up to two weeks after the start of your period.\nIf you have migraines throughout your menstrual cycle or you have irregular periods, your doctor may recommend that you take preventive medications every day.\nDaily medications may include beta blockers, anticonvulsants, calcium channel blockers, antidepressants or magnesium. Doctors will review any other medical conditions you may have to determine which medications may be most appropriate for you.\nMaking lifestyle changes, such as reducing stress and exercising regularly, also may help reduce the frequency, length and severity of migraines.",
    decodedTokens: [
      " your",
      " brain",
      ".",
      " T",
      "ript",
      "ans",
      " often",
      " may",
      " relieve",
      " pain",
      " from",
      " your",
      " headache",
      " within",
      " two",
      " hours",
      " and",
      " help",
      " to",
      " control",
      " vomiting",
      ".",
      "\n",
      "-",
      " Take",
      " pain",
      " relie",
      "vers",
      " and",
      " tri",
      "pt",
      "ans",
      ".",
      " Some",
      " women",
      " may",
      " take",
      " a",
      " combination",
      " of",
      " NSA",
      "IDs",
      " and",
      " tri",
      "pt",
      "ans",
      " to",
      " relieve",
      " pain",
      " from",
      " menstrual",
      " mig",
      "rain",
      "es",
      ".",
      "\n",
      "-",
      " Take",
      " other",
      " prescription",
      " pain",
      " medications",
      ".",
      " Sometimes",
      " your",
      " doctor",
      " may",
      " suggest",
      " other",
      " prescription",
      " pain",
      " medications",
      ",",
      " such",
      " as",
      " di",
      "hyd",
      "ro",
      "erg",
      "ot",
      "amine",
      " (",
      "D",
      "ih",
      "yd",
      "ro",
      "erg",
      "ot",
      "amine",
      " Mes",
      "yl",
      "ate",
      ").",
      "\n",
      "If",
      " you",
      " have",
      " several",
      " debilitating",
      " headaches",
      " a",
      " month",
      ",",
      " your",
      " doctor",
      " may",
      " recommend",
      " preventive",
      " treatment",
      " with",
      " NSA",
      "IDs",
      " or",
      " tri",
      "pt",
      "ans",
      ".",
      "\n",
      "If",
      " your",
      " menstrual",
      " cycle",
      " is",
      " regular",
      ",",
      " it",
      "'s",
      " often",
      " most",
      " effective",
      " to",
      " take",
      " preventive",
      " headache",
      " medication",
      " starting",
      " a",
      " few",
      " days",
      " before",
      " your",
      " period",
      " and",
      " continuing",
      " through",
      " up",
      " to",
      " two",
      " weeks",
      " after",
      " the",
      " start",
      " of",
      " your",
      " period",
      ".",
      "\n",
      "If",
      " you",
      " have",
      " mig",
      "rain",
      "es",
      " throughout",
      " your",
      " menstrual",
      " cycle",
      " or",
      " you",
      " have",
      " irregular",
      " periods",
      ",",
      " your",
      " doctor",
      " may",
      " recommend",
      " that",
      " you",
      " take",
      " preventive",
      " medications",
      " every",
      " day",
      ".",
      "\n",
      "Daily",
      " medications",
      " may",
      " include",
      " beta",
      " blockers",
      ",",
      " ant",
      "icon",
      "v",
      "uls",
      "ants",
      ",",
      " calcium",
      " channel",
      " blockers",
      ",",
      " antidepressants",
      " or",
      " magnesium",
      ".",
      " Doctors",
      " will",
      " review",
      " any",
      " other",
      " medical",
      " conditions",
      " you",
      " may",
      " have",
      " to",
      " determine",
      " which",
      " medications",
      " may",
      " be",
      " most",
      " appropriate",
      " for",
      " you",
      ".",
      "\n",
      "Making",
      " lifestyle",
      " changes",
      ",",
      " such",
      " as",
      " reducing",
      " stress",
      " and",
      " exercising",
      " regularly",
      ",",
      " also",
      " may",
      " help",
      " reduce",
      " the",
      " frequency",
      ",",
      " length",
      " and",
      " severity",
      " of",
      " mig",
      "rain",
      "es",
      ".",
    ],
    activations: [
      0, 0, 0, 0, 0, 0.871, 0.831, 0.771, 0.424, 0, 0, 0, 0, 0, 0, 0, 0.445, 0, 0, 0, 0, 0.796,
      0.692, 0.926, 1.159, 0.444, 0, 1.064, 1.335, 0.743, 0, 1.131, 1.088, 1.176, 0.771, 1.041,
      1.522, 1.146, 1.389, 1.538, 0.357, 1.446, 1.623, 0.952, 0.358, 1.494, 1.096, 0.475, 0, 0, 0,
      0, 0, 0, 1.112, 0.583, 1.109, 1.287, 1.26, 1.197, 0.955, 1.336, 1.345, 1.25, 0.426, 0.492,
      0.792, 1.614, 1.556, 1.483, 1.213, 1.369, 1.205, 0.489, 1.964, 0.942, 0.321, 0.678, 0.558,
      0.896, 1.535, 1.351, 1.115, 0, 0.384, 0.872, 0.779, 1.116, 1.31, 0.807, 0.693, 1.245, 1.174,
      0.565, 0.348, 0.437, 0, 0.49, 0, 0, 0.279, 0, 0.477, 0, 0, 0, 1.063, 0.779, 0.647, 1.32,
      0.273, 1.132, 1.363, 0.819, 0.258, 1.32, 0.991, 0.567, 0, 0, 0, 0, 0, 0, 0.626, 0, 0, 0, 0,
      0.339, 0.723, 1.309, 0.955, 1.18, 1.144, 0.38, 0, 0, 0, 0, 0, 0, 0.525, 0.82, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0.711, 0.503, 0, 0.35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.679, 0, 0,
      0.446, 0.99, 0.536, 0.861, 1.526, 0.902, 1.07, 0.27, 0.576, 0.738, 0.485, 0.515, 1.138, 0.842,
      1.407, 0.752, 0.916, 1.554, 1.099, 0, 0, 0, 0.94, 1.661, 1.082, 0.518, 0.642, 1.543, 0.608,
      1.432, 0.799, 1.021, 0, 0.372, 0.651, 0.692, 1.04, 0.422, 0, 0, 0, 0, 0.51, 0, 0.941, 1.136,
      0.949, 1.22, 0.864, 0.491, 0, 0, 0.585, 0.613, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0, 0.4393297159046564, 0.41915383916965493, 0.38889002406715284,
      0.2138642933910153, 0, 0, 0, 0, 0, 0, 0, 0.22445662867689106, 0, 0, 0, 0, 0.40149994702652875,
      0.34904266751552493, 0.4670715464152834, 0.5845960283966668, 0.223952231758516, 0,
      0.5366783211510384, 0.6733698860306732, 0.3747669103526518, 0, 0.5704729146821658,
      0.5487838471920393, 0.5931707760090423, 0.38889002406715284, 0.5250771920284125,
      0.7676921097668049, 0.5780388684577913, 0.7006073196229251, 0.7757624604608054,
      0.18006969985988786, 0.7293579439703021, 0.8186361985226835, 0.48018586629303434,
      0.18057409677826292, 0.7535689960523039, 0.5528190225390396, 0.2395885362281421, 0, 0, 0, 0,
      0, 0, 0.5608893732330401, 0.29406340341264603, 0.559376182477915, 0.6491588339486714,
      0.6355401171525454, 0.6037631112949182, 0.4816990570481594, 0.6738742829490482,
      0.6784138552144235, 0.630496147968795, 0.21487308722776535, 0.24816328384051775,
      0.39948235935302856, 0.8140966262573083, 0.7848416049915561, 0.7480206299501785,
      0.6118334619889187, 0.6905193812554243, 0.6077982866419185, 0.24665009308539262,
      0.9906355476885708, 0.47514189710928395, 0.16191141079838658, 0.34198111065827447,
      0.2814534804532701, 0.4519396388640323, 0.7742492697056803, 0.6814402367246737,
      0.5624025639881652, 0, 0.19368841665601386, 0.4398341128230314, 0.3929251994141531,
      0.5629069609065402, 0.6607599630712973, 0.40704831312865414, 0.3495470644339,
      0.6279741633769199, 0.5921619821722923, 0.2849842588818953, 0.17553012759451253,
      0.22042145332989077, 0, 0.24715449000376766, 0, 0, 0.14072674022663506, 0, 0.2405973300648922,
      0, 0, 0, 0.5361739242326633, 0.3929251994141531, 0.32634480618864836, 0.6658039322550476,
      0.13770035871638486, 0.5709773116005408, 0.6874929997451742, 0.41310107614915453,
      0.1301344049407593, 0.6658039322550476, 0.49985734610966076, 0.28599305271864545, 0, 0, 0, 0,
      0, 0, 0.3157524709027726, 0, 0, 0, 0, 0.17099055532913723, 0.36467897198515103,
      0.6602555661529221, 0.4816990570481594, 0.5951883636825426, 0.5770300746210412,
      0.1916708289825137, 0, 0, 0, 0, 0, 0, 0.26480838214689395, 0.41360547306752954, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0.35862620896465064, 0.2537116499426431, 0, 0.17653892143126262, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.34248550757664953, 0, 0, 0.2249610255952661, 0.4993529491912857,
      0.27035674824901934, 0.43428574672090603, 0.769709697440305, 0.4549660203742825,
      0.5397047026612887, 0.13618716796125974, 0.29053262498402077, 0.3722449257607766,
      0.2446325054118925, 0.25976441296314356, 0.574003693110791, 0.4247022052717804,
      0.7096864641536758, 0.37930648261802713, 0.46202757723153304, 0.7838328111548061,
      0.5543322132941646, 0, 0, 0, 0.4741331032725339, 0.837803281420935, 0.5457574656817891,
      0.2612776037182687, 0.32382282159677317, 0.7782844450526806, 0.30667332637202194,
      0.7222963871130517, 0.4030131377816538, 0.5149892536609117, 0, 0.1876356536355134,
      0.3283623938621485, 0.34904266751552493, 0.5245727951100375, 0.21285549955426522, 0, 0, 0, 0,
      0.2572424283712684, 0, 0.4746375001909089, 0.5729948992740409, 0.4786726755379092,
      0.615364240417544, 0.43579893747603116, 0.2476588869221427, 0, 0, 0.2950721972493961,
      0.3091953109638971, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0,
    ],
    targetIdx: 74,
    absoluteTokenIdx: 6715978,
    modelId: "mini",
  },
  {
    sampleText:
      " condition that is thought to be caused by a breakdown of the skin’s barrier, which allows moisture in the skin to escape, leading to inflammation in the skin.\nEczema is often seen in children, though it can flare at any point during a person’s life. During the winter months in Minnesota, as the humidity drops, we see many patients who are experiencing eczema flares for the first time. Treatment for eczema is different for every person.\nThere are sometimes lifestyle factors (such as jobs that require excessive hand washing or people who develop a contact allergy to the dyes in their clothing) that must be addressed. For all patients, we recommend using a daily moisturizing cream (a thick cream that comes in a jar, such as Cerave cream, rather than a lotion) in the morning and evening.\nAdding moisture to the skin can sometimes help as much as prescription medications! Regular moisturizing helps to prevent eczema flares during the dry winter months.\nPrescription medications for eczema can be very helpful for treating an eczema flare. Topical steroid medications (such as triamcinolone, desonide, and clobetasol) can be used for short periods of time",
    decodedTokens: [
      " condition",
      " that",
      " is",
      " thought",
      " to",
      " be",
      " caused",
      " by",
      " a",
      " breakdown",
      " of",
      " the",
      " skin",
      "\\xe2\\x80",
      "\\x99",
      "s",
      " barrier",
      ",",
      " which",
      " allows",
      " moisture",
      " in",
      " the",
      " skin",
      " to",
      " escape",
      ",",
      " leading",
      " to",
      " inflammation",
      " in",
      " the",
      " skin",
      ".",
      "\n",
      "E",
      "cz",
      "ema",
      " is",
      " often",
      " seen",
      " in",
      " children",
      ",",
      " though",
      " it",
      " can",
      " flare",
      " at",
      " any",
      " point",
      " during",
      " a",
      " person",
      "\\xe2\\x80",
      "\\x99",
      "s",
      " life",
      ".",
      " During",
      " the",
      " winter",
      " months",
      " in",
      " Minnesota",
      ",",
      " as",
      " the",
      " humidity",
      " drops",
      ",",
      " we",
      " see",
      " many",
      " patients",
      " who",
      " are",
      " experiencing",
      " ec",
      "z",
      "ema",
      " flares",
      " for",
      " the",
      " first",
      " time",
      ".",
      " Treatment",
      " for",
      " ec",
      "z",
      "ema",
      " is",
      " different",
      " for",
      " every",
      " person",
      ".",
      "\n",
      "There",
      " are",
      " sometimes",
      " lifestyle",
      " factors",
      " (",
      "such",
      " as",
      " jobs",
      " that",
      " require",
      " excessive",
      " hand",
      " washing",
      " or",
      " people",
      " who",
      " develop",
      " a",
      " contact",
      " allergy",
      " to",
      " the",
      " d",
      "yes",
      " in",
      " their",
      " clothing",
      ")",
      " that",
      " must",
      " be",
      " addressed",
      ".",
      " For",
      " all",
      " patients",
      ",",
      " we",
      " recommend",
      " using",
      " a",
      " daily",
      " moistur",
      "izing",
      " cream",
      " (",
      "a",
      " thick",
      " cream",
      " that",
      " comes",
      " in",
      " a",
      " jar",
      ",",
      " such",
      " as",
      " Cer",
      "ave",
      " cream",
      ",",
      " rather",
      " than",
      " a",
      " lot",
      "ion",
      ")",
      " in",
      " the",
      " morning",
      " and",
      " evening",
      ".",
      "\n",
      "Adding",
      " moisture",
      " to",
      " the",
      " skin",
      " can",
      " sometimes",
      " help",
      " as",
      " much",
      " as",
      " prescription",
      " medications",
      "!",
      " Regular",
      " moistur",
      "izing",
      " helps",
      " to",
      " prevent",
      " ec",
      "z",
      "ema",
      " flares",
      " during",
      " the",
      " dry",
      " winter",
      " months",
      ".",
      "\n",
      "Pres",
      "cription",
      " medications",
      " for",
      " ec",
      "z",
      "ema",
      " can",
      " be",
      " very",
      " helpful",
      " for",
      " treating",
      " an",
      " ec",
      "z",
      "ema",
      " flare",
      ".",
      " Top",
      "ical",
      " steroid",
      " medications",
      " (",
      "such",
      " as",
      " tri",
      "am",
      "cin",
      "ol",
      "one",
      ",",
      " des",
      "on",
      "ide",
      ",",
      " and",
      " cl",
      "ob",
      "et",
      "as",
      "ol",
      ")",
      " can",
      " be",
      " used",
      " for",
      " short",
      " periods",
      " of",
      " time",
    ],
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.372, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.628, 0.678, 0.727, 0.773, 0,
      0.615, 0, 0.419, 0.559, 0, 0, 0, 0.21, 0.416, 0, 0, 0.46, 0.632, 0, 0.584, 0.636, 0, 0.547,
      0.947, 0, 0, 0, 0, 0, 0.473, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.658, 0.959, 0, 0, 0, 0.645,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.815, 0.994, 0, 0, 0, 0, 0.662, 0.769, 0.698,
      0.448, 0, 0, 0, 0, 0, 0, 0, 0.818, 0.749, 1.251, 1.079, 1.476, 1.629, 0.852, 1.96, 1.026,
      0.251, 0.612, 0.58, 1.417, 1.912, 0.968, 0.49, 1.103, 1.827, 1.754, 0.999, 0.532, 0.769,
      0.722, 0.641, 1.448, 1.271, 1.341, 1.281, 0.735, 0, 0.285, 0, 0.453,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.1876356536355134, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.31676126473952265, 0.34198111065827447, 0.3666965596586512, 0.3898988179039029, 0,
      0.3102041048006472, 0, 0.2113423087991401, 0.2819578773716452, 0, 0, 0, 0.10592335285875756,
      0.209829118044015, 0, 0, 0.2320225824525166, 0.3187788524130228, 0, 0.29456780033102103,
      0.3207964400865229, 0, 0.27590511435114473, 0.47766388170115914, 0, 0, 0, 0, 0,
      0.23857974239139204, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.33189317229077375,
      0.48371664472165954, 0, 0, 0, 0.3253360123518983, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.41108348847565435, 0.5013705368647858, 0, 0, 0, 0, 0.3339107599642739, 0.3878812302304027,
      0.3520690490257751, 0.22596981943201616, 0, 0, 0, 0, 0, 0, 0, 0.4125966792307795,
      0.377793291862902, 0.6310005448871701, 0.5442442749266639, 0.7444898515215532,
      0.8216625800329338, 0.4297461744555307, 0.9886179600150706, 0.517511238252787,
      0.12660362651213405, 0.30869091404552207, 0.2925502126575209, 0.7147304333374261,
      0.9644069079330689, 0.4882562169870349, 0.24715449000376766, 0.5563498009676647,
      0.9215331698711908, 0.8847121948298132, 0.5038925214566611, 0.2683391605755192,
      0.3878812302304027, 0.36417457506677603, 0.3233184246783981, 0.7303667378070522,
      0.6410884832546708, 0.6763962675409233, 0.6461324524384211, 0.3707317350056515, 0,
      0.14375312173688526, 0, 0.22849180402389135,
    ],
    targetIdx: 230,
    absoluteTokenIdx: 1978342,
    modelId: "mini",
  },
  {
    sampleText:
      " condition that is thought to be caused by a breakdown of the skin’s barrier, which allows moisture in the skin to escape, leading to inflammation in the skin.\nEczema is often seen in children, though it can flare at any point during a person’s life. During the winter months in Minnesota, as the humidity drops, we see many patients who are experiencing eczema flares for the first time. Treatment for eczema is different for every person.\nThere are sometimes lifestyle factors (such as jobs that require excessive hand washing or people who develop a contact allergy to the dyes in their clothing) that must be addressed. For all patients, we recommend using a daily moisturizing cream (a thick cream that comes in a jar, such as Cerave cream, rather than a lotion) in the morning and evening.\nAdding moisture to the skin can sometimes help as much as prescription medications! Regular moisturizing helps to prevent eczema flares during the dry winter months.\nPrescription medications for eczema can be very helpful for treating an eczema flare. Topical steroid medications (such as triamcinolone, desonide, and clobetasol) can be used for short periods of time",
    decodedTokens: [
      " condition",
      " that",
      " is",
      " thought",
      " to",
      " be",
      " caused",
      " by",
      " a",
      " breakdown",
      " of",
      " the",
      " skin",
      "\\xe2\\x80",
      "\\x99",
      "s",
      " barrier",
      ",",
      " which",
      " allows",
      " moisture",
      " in",
      " the",
      " skin",
      " to",
      " escape",
      ",",
      " leading",
      " to",
      " inflammation",
      " in",
      " the",
      " skin",
      ".",
      "\n",
      "E",
      "cz",
      "ema",
      " is",
      " often",
      " seen",
      " in",
      " children",
      ",",
      " though",
      " it",
      " can",
      " flare",
      " at",
      " any",
      " point",
      " during",
      " a",
      " person",
      "\\xe2\\x80",
      "\\x99",
      "s",
      " life",
      ".",
      " During",
      " the",
      " winter",
      " months",
      " in",
      " Minnesota",
      ",",
      " as",
      " the",
      " humidity",
      " drops",
      ",",
      " we",
      " see",
      " many",
      " patients",
      " who",
      " are",
      " experiencing",
      " ec",
      "z",
      "ema",
      " flares",
      " for",
      " the",
      " first",
      " time",
      ".",
      " Treatment",
      " for",
      " ec",
      "z",
      "ema",
      " is",
      " different",
      " for",
      " every",
      " person",
      ".",
      "\n",
      "There",
      " are",
      " sometimes",
      " lifestyle",
      " factors",
      " (",
      "such",
      " as",
      " jobs",
      " that",
      " require",
      " excessive",
      " hand",
      " washing",
      " or",
      " people",
      " who",
      " develop",
      " a",
      " contact",
      " allergy",
      " to",
      " the",
      " d",
      "yes",
      " in",
      " their",
      " clothing",
      ")",
      " that",
      " must",
      " be",
      " addressed",
      ".",
      " For",
      " all",
      " patients",
      ",",
      " we",
      " recommend",
      " using",
      " a",
      " daily",
      " moistur",
      "izing",
      " cream",
      " (",
      "a",
      " thick",
      " cream",
      " that",
      " comes",
      " in",
      " a",
      " jar",
      ",",
      " such",
      " as",
      " Cer",
      "ave",
      " cream",
      ",",
      " rather",
      " than",
      " a",
      " lot",
      "ion",
      ")",
      " in",
      " the",
      " morning",
      " and",
      " evening",
      ".",
      "\n",
      "Adding",
      " moisture",
      " to",
      " the",
      " skin",
      " can",
      " sometimes",
      " help",
      " as",
      " much",
      " as",
      " prescription",
      " medications",
      "!",
      " Regular",
      " moistur",
      "izing",
      " helps",
      " to",
      " prevent",
      " ec",
      "z",
      "ema",
      " flares",
      " during",
      " the",
      " dry",
      " winter",
      " months",
      ".",
      "\n",
      "Pres",
      "cription",
      " medications",
      " for",
      " ec",
      "z",
      "ema",
      " can",
      " be",
      " very",
      " helpful",
      " for",
      " treating",
      " an",
      " ec",
      "z",
      "ema",
      " flare",
      ".",
      " Top",
      "ical",
      " steroid",
      " medications",
      " (",
      "such",
      " as",
      " tri",
      "am",
      "cin",
      "ol",
      "one",
      ",",
      " des",
      "on",
      "ide",
      ",",
      " and",
      " cl",
      "ob",
      "et",
      "as",
      "ol",
      ")",
      " can",
      " be",
      " used",
      " for",
      " short",
      " periods",
      " of",
      " time",
    ],
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.372, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.628, 0.678, 0.727, 0.773, 0,
      0.615, 0, 0.419, 0.559, 0, 0, 0, 0.21, 0.416, 0, 0, 0.46, 0.632, 0, 0.584, 0.636, 0, 0.547,
      0.947, 0, 0, 0, 0, 0, 0.473, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.658, 0.959, 0, 0, 0, 0.645,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.815, 0.994, 0, 0, 0, 0, 0.662, 0.769, 0.698,
      0.448, 0, 0, 0, 0, 0, 0, 0, 0.818, 0.749, 1.251, 1.079, 1.476, 1.629, 0.852, 1.96, 1.026,
      0.251, 0.612, 0.58, 1.417, 1.912, 0.968, 0.49, 1.103, 1.827, 1.754, 0.999, 0.532, 0.769,
      0.722, 0.641, 1.448, 1.271, 1.341, 1.281, 0.735, 0, 0.285, 0, 0.453,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.1876356536355134, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.31676126473952265, 0.34198111065827447, 0.3666965596586512, 0.3898988179039029, 0,
      0.3102041048006472, 0, 0.2113423087991401, 0.2819578773716452, 0, 0, 0, 0.10592335285875756,
      0.209829118044015, 0, 0, 0.2320225824525166, 0.3187788524130228, 0, 0.29456780033102103,
      0.3207964400865229, 0, 0.27590511435114473, 0.47766388170115914, 0, 0, 0, 0, 0,
      0.23857974239139204, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.33189317229077375,
      0.48371664472165954, 0, 0, 0, 0.3253360123518983, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.41108348847565435, 0.5013705368647858, 0, 0, 0, 0, 0.3339107599642739, 0.3878812302304027,
      0.3520690490257751, 0.22596981943201616, 0, 0, 0, 0, 0, 0, 0, 0.4125966792307795,
      0.377793291862902, 0.6310005448871701, 0.5442442749266639, 0.7444898515215532,
      0.8216625800329338, 0.4297461744555307, 0.9886179600150706, 0.517511238252787,
      0.12660362651213405, 0.30869091404552207, 0.2925502126575209, 0.7147304333374261,
      0.9644069079330689, 0.4882562169870349, 0.24715449000376766, 0.5563498009676647,
      0.9215331698711908, 0.8847121948298132, 0.5038925214566611, 0.2683391605755192,
      0.3878812302304027, 0.36417457506677603, 0.3233184246783981, 0.7303667378070522,
      0.6410884832546708, 0.6763962675409233, 0.6461324524384211, 0.3707317350056515, 0,
      0.14375312173688526, 0, 0.22849180402389135,
    ],
    targetIdx: 236,
    absoluteTokenIdx: 1978348,
    modelId: "mini",
  },
];

export { Sample1125000 };
